interface CloseIconProps {
    color?: string;
    circleColor?: string;
    className?: string;
}

function CloseIcon({ color = '#fff', circleColor = '#222', className = null }: CloseIconProps) {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <circle cx="20" cy="20" r="20" fill={circleColor} stroke="transparent" />
            <path d="M12 12L28 28" stroke={color} strokeWidth="2" strokeLinecap="round" />
            <path d="M12 28L28 12" stroke={color} strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
}

export default CloseIcon;
